// extracted by mini-css-extract-plugin
export default {"container":"b2XUJ0"};